// import {cartStore} from '@woocommerce/block-data';
import {select, subscribe, useSelect} from '@wordpress/data';
import {useEffect} from '@wordpress/element';
import {registerPlugin} from '@wordpress/plugins';
import {registerCheckoutFilters} from '@woocommerce/blocks-checkout';

const cartStore = 'wc/store/cart' // import {cartStore} gives error in editor (iFrame) when executing on module load

export function getSelectedShippingRates(shippingRates) {
	return shippingRates.map((packageData) => {
		return packageData?.shipping_rates?.find(rate => rate.selected === true)
	}).filter((i) => i !== undefined) // Can it even be undefined?
}

export function hasQuoteShippingRateSelected(shippingRates) {
	return getSelectedShippingRates(shippingRates).filter(rate => rate.method_id === 'custom_shipping_quote').length > 0;
}

// Change shipping cost text. This cannot be done any other way :')
function updateQuoteShippingOptionCostText() {
	const cartData = select(cartStore).getCartData();
	const cfsqData = cartData?.extensions?.['contact-for-shipping-quote'] ?? false;
	if (cfsqData.quote?.status !== 'pending') {
		document.querySelectorAll('' +
			'.wc-block-checkout__shipping-option input[id*=custom_shipping_quote] + div .wc-block-checkout__shipping-option--free,' +
			'.wp-block-woocommerce-checkout-order-summary-shipping-block .wc-block-components-totals-item__value,' +
			'.wp-block-woocommerce-cart-order-summary-shipping-block .wc-block-components-totals-item__value'
		).forEach(el => el.textContent = '');
	}
}

document.addEventListener('DOMContentLoaded', () => { // Needs to be in here to make querySelector work within observer
	const observer = new MutationObserver(updateQuoteShippingOptionCostText);
	const el = document.querySelector('.wc-block-checkout__shipping-option, .wp-block-woocommerce-cart-order-summary-block');
	const node = el?.getRootNode();
	if (node) observer.observe(node, {childList: true, subtree: true});
}) // 4 calls
// subscribe(updateQuoteShippingOptionCostText, 'wc/store/cart'); // Alternative way instead of mutation observer, 7 calls, doesn't work for all cases


// Hide order button
let lastStatus = null;
const updatePlaceOrderVisibility = () => {
	const cart = select(cartStore).getCartData();
	const quoteStatus = cart?.extensions?.['contact-for-shipping-quote']?.quote?.status;
	const hideOrderButton = cart?.extensions?.['contact-for-shipping-quote']?.['hide-order-button']

	if (!hideOrderButton || quoteStatus === lastStatus) {
		return; // avoid unnecessary DOM writes on every cart update
	}
	lastStatus = quoteStatus;

	const checkoutEl = document.querySelector('.wp-block-woocommerce-checkout');
	if (!checkoutEl) {
		return;
	}

	const quoteRequested = quoteStatus && quoteStatus !== 'pending' && quoteStatus !== null;
	checkoutEl.classList.toggle('wccsq-hide-place-order', quoteRequested);
};
subscribe(updatePlaceOrderVisibility, cartStore);

// Run once on load too, since subscribe() only fires on future changes.
// updatePlaceOrderVisibility();



// Change order button text
const customPlaceOrderButtonLabel = (buttonText, extensions) => {
	const cart = select('wc/store/cart').getCartData();
	const quote = cart.extensions['contact-for-shipping-quote']?.quote;

	if (!quote || (quote && quote?.status !== 'pending')) {
		buttonText = cart.extensions['contact-for-shipping-quote']?.['order-button-text'] ?? buttonText;
	}

	if (quote && quote?.status === 'new') {
		buttonText = cart.extensions['contact-for-shipping-quote']['order-button-text-requested'] ?? buttonText;
	}

	return buttonText;
}


const rerenderPlaceOrderButton = () => {
	// This is sooooo wrong, but needed to invalidate the filter cache.
	// The order label text is cached, registering a checkout filter is the only way to invalidate the cache.
	registerCheckoutFilters('wccsq-shipping-watcher', {
		placeOrderButtonLabel: customPlaceOrderButtonLabel,
	});
}
rerenderPlaceOrderButton();

const shippingWatcher = () => {
	// Subscribes to shipping rate changes
	const shippingRates = useSelect((select) => {
		return select(cartStore).getShippingRates();
	})

	useEffect(() => {
		rerenderPlaceOrderButton();
	}, [shippingRates])

	return null;
}

// Use registerPlugin why? (is it because this allows for using useEffect?)
registerPlugin('wccsq-shipping-watcher', {
	render: shippingWatcher,
	scope: 'woocommerce-checkout'
})


// Set as allowed inner blow - to allow for adding the block (if deleted)
document.addEventListener('DOMContentLoaded', () => {
	const {registerCheckoutFilters} = window.wc.blocksCheckout;

	registerCheckoutFilters('woocommerce-contact-for-shipping-quote/contact-for-shipping-quote', {
		additionalCartCheckoutInnerBlockTypes: (value, extensions, args) => {
			if (args?.block === 'woocommerce/checkout-shipping-methods-block') {
				value.push('woocommerce-contact-for-shipping-quote/contact-for-shipping-quote');
			}

			return value;
		},
	});
});
